"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ValidationRender_1 = __importDefault(require("./ValidationRender"));
/**
 * This component is used to ensure that the full validation function isn't created for simple required field, or nonexistent validations.
 * Full validation requires subscribing to formstate changes, which can be expensive, by placing this component in front of the
 * actual validation creation, we can optimize and skip that subscription
 * @param controlDefinition the control to validate
 */
const ValidationOptimizer = (props) => {
    const { controlDefinition: { options, warningMap, errorMap, required, label, type }, render, } = props;
    const { min, max } = props.controlDefinition;
    // we're going to create a validation function that returns errors and warnings
    const validationFn = react_1.useCallback((value) => {
        const hasLocation = (val) => Array.isArray(val) ? (val.length && val.every(v => v === null || v === void 0 ? void 0 : v.location)) : val === null || val === void 0 ? void 0 : val.location;
        if (required && (!value || type === 'location' && !hasLocation(value))) {
            return { errors: [`${label} is required`], warnings: [] };
        }
        if (min && max && min > 0 && max > 0 && min > max) {
            return { errors: [], warnings: [] };
        }
        if (min && min > 0 && Array.isArray(value) && value.length < min) {
            return { errors: [`Number of files selected does not meet the minimum of ${min}`], warnings: [] };
        }
        if (max && max > 0 && Array.isArray(value) && value.length > max) {
            return { errors: [`Number of files selected exceeds the maximum of ${max}`], warnings: [] };
        }
        return { errors: [], warnings: [] };
    }, [required, label, min, max, type]);
    if (warningMap || errorMap || (options && options.optionsMap)) {
        // in this case we have to fall back to rendering using the full validation function
        return react_1.default.createElement(ValidationRender_1.default, { controlDefinition: props.controlDefinition, render: render });
    }
    else {
        if (!required && !min && !max) {
            return render(undefined); //<Component {...props} />;
        }
        else {
            return render(validationFn);
        }
    }
};
exports.default = ValidationOptimizer;
